import { render, staticRenderFns } from "./CharacterReviewInterface.vue?vue&type=template&id=4b29c3b2&"
import script from "./CharacterReviewInterface.vue?vue&type=script&lang=js&"
export * from "./CharacterReviewInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports